var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Tokenizer from './tokenizer/tokenizer';
import { types } from './tokenizer/types';
import createAbstractSyntaxTree from './abstract-syntax-tree';

var Parser = function () {
  function Parser() {
    _classCallCheck(this, Parser);

    this.functions = {};
    this.properties = {};
  }

  _createClass(Parser, [{
    key: 'registerFunction',
    value: function registerFunction(name, handler) {
      if (this.functions[name]) {
        throw new SyntaxError('Function \'' + name + '\' has already been declared');
      }

      this.functions[name] = handler;
    }
  }, {
    key: 'unRegisterFunction',
    value: function unRegisterFunction(name) {
      delete this.functions[name];
    }
  }, {
    key: 'registerProperty',
    value: function registerProperty(name, handler) {
      if (this.properties[name]) {
        throw new SyntaxError('Property \'' + name + '\' has already been declared');
      }

      this.properties[name] = handler;
    }
  }, {
    key: 'unRegisterProperty',
    value: function unRegisterProperty(name) {
      delete this.properties[name];
    }
  }, {
    key: 'parse',
    value: function parse(expression) {
      var _this = this;

      var options = { identifiers: [] };
      var tokenizer = new Tokenizer(expression);
      var compiled = createAbstractSyntaxTree(tokenizer, options);

      if (!tokenizer.token.match(types.EOF)) {
        throw new SyntaxError('Unexpected end of expression');
      }

      return Object.assign({}, options, {
        eval: function _eval(scope) {
          return compiled(scope, {
            functions: _this.functions,
            properties: _this.properties
          });
        }
      });
    }
  }, {
    key: 'parseAndEval',
    value: function parseAndEval(expression) {
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.parse(expression).eval(scope);
    }
  }]);

  return Parser;
}();

export default Parser;